import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

function backLabelForPath(path) {
  if (path === "/old1/home") return "Back to home";
  if (path === "/old1/blog") return "Back to articles";
  if (path === "/") return "Back";
  return "Back";
}

export default function old1_PublicBackLink({ fallbackTo = "/old1/home", label, fixed = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const from = fixed ? null : typeof location.state?.from === "string" ? location.state.from : null;
  const destination = from || fallbackTo;
  const resolvedLabel =
    label || location.state?.backLabel || (from ? backLabelForPath(from) : backLabelForPath(fallbackTo));

  const content = (
    <>
      <ArrowLeft className="jw-public-icon" aria-hidden="true" />
      {resolvedLabel}
    </>
  );

  if (fixed) {
    return (
      <Link className="back-link jw-public-back-link" to={fallbackTo}>
        {content}
      </Link>
    );
  }

  if (from) {
    return (
      <Link className="back-link jw-public-back-link" to={from}>
        {content}
      </Link>
    );
  }

  if (location.key !== "default") {
    return (
      <button
        type="button"
        className="back-link jw-public-back-link"
        onClick={() => navigate(-1)}
      >
        {content}
      </button>
    );
  }

  return (
    <Link className="back-link jw-public-back-link" to={destination}>
      {content}
    </Link>
  );
}
